import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

// Wave-17 Item 1.1 — Account activation page lazy-loaded (only hit once
// per user from an email link).
export const Route = createFileRoute('/account_activation/$uid/$token')({
  component: lazyRouteComponent(
    () => import('@/pages/AccountActivation/Page'),
  ),
});
